import { EmployeeModel } from '../../models/employee.model';
import * as EmployeeActions from '../actions/employee.action';

const getEmployeeInitialState = (): EmployeeModel => {
  return JSON.parse(localStorage.getItem('employee'));
};

const initialState: EmployeeModel = getEmployeeInitialState();

export const employeeReducer = (
  state: EmployeeModel = initialState,
  action: EmployeeActions.Actions
): any => {
  switch (action.type) {
    case EmployeeActions.LOGIN_EMPLOYEE:
      localStorage.setItem('employee', JSON.stringify(action.payload));
      return { ...state, ...action.payload };
    case EmployeeActions.LOGOUT_EMPLOYEE:
      return null;
    default:
      return state;
  }
};
